import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AuthWrapper2/hooks/useAuthActions.ts
function useAuthActions() {
	const authVM = useSingleton(AuthViewModel);
	return {
		changeUser: authVM.changeUser,
		logout: authVM.logout
	};
}
//#endregion
export { useAuthActions };

//# sourceMappingURL=useAuthActions.js.map